"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var background = function (color) { return "background: " + color + ";"; };
exports.default = (function (_a) {
    var active = _a.active, hovered = _a.hovered;
    return function (_a) {
        var theme = _a.theme;
        if (hovered) {
            return background(theme.palette.dropdownBackground[1]);
        }
        if (active) {
            return background(theme.palette.dropdownBackground[2]);
        }
        return background(theme.palette.dropdownBackground[0]);
    };
});
